import { useState } from "react";
import { callApiIO } from "../../api";
import { useAuth } from "../useAuth";

export default () => {
  const [campaignsD, setCampaignsD] = useState([]);
  const { selectedBusiness } = useAuth();
  const useCampaigns = async () => {
    try{
      const res = await callApiIO(
        `/protected/business/${selectedBusiness.id}/iorequest?dest=${encodeURIComponent(
          "business/:BID:/getCampaigns"
        )}`
      ); 
    setCampaignsD(res?.data);
    if (res && res.status === true) {
      setCampaignsD(res?.data);
  
      return res?.data;
    }}
    catch(e){
      // eslint-disable-next-line no-console
      console.log("error",e)
      return null
    }
  };
  return {
     useCampaigns,campaignsD
  };
};
